<template>
    <sa-page-layout slot="table-body" :btnConfigurazioniVisible="btnConfigurazioniVisible" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :showModalLoading="showModalLoading" :btnRouterBackVisible="false" :linkConfigurazioni="linkConfigurazioni">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovoFornitore">
                <b-icon icon="plus"></b-icon>
                Nuovo
            </b-button>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Ragione Sociale: </label>
                        <b-form-input v-model="filtroFornitore.ragioneSocialeFornitore" type="search" id="nome" placeholder="Inserire Ragione Sociale"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Codice Fornitore: </label>
                        <b-form-input v-model="filtroFornitore.codiceFornitore" type="search" id="nome" placeholder="Inserire Codice Fornitore"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Partita Iva: </label>
                        <b-form-input v-model="filtroFornitore.partitaIvaFornitore" type="search" placeholder="Inserire P.Iva"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info"> {{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <configurazioni-magazzino-fornitori-list-component ref="cmpConfigurazioniMagazzinoFornitoriList" />
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import ConfigurazioniMagazzinoFornitoriListComponent from "../components/ConfigurazioniMagazzinoFornitoriListComponent.vue";
export default {
    name: "ConfigurazioniMagazzinoFornitoreListPage",
    components: { SaPageLayout, ConfigurazioniMagazzinoFornitoriListComponent },
    data() {
        return {
            filtroFornitore: {
                ragioneSocialeFornitore: null,
                codiceFornitore: null,
                partitaIvaFornitore: null,
            },
            btnNewVisible: false,
            btnConfigurazioniVisible: true,
            pathResource: "",
            linkConfigurazioni: "/configurazionemagazzino",
            showModalLoading: false,
        };
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.$refs.cmpConfigurazioniMagazzinoFornitoriList.loadDataFornitori();
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroFornitore"] = JSON.stringify(me.filtroFornitore);
            me.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onReset() {
            let me = this;
            me.filtroFornitore = { ragioneSocialeFornitore: null, codiceFornitore: null, partitaIvaFornitore: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroFornitore"] = JSON.stringify(me.filtroFornitore);
            me.loadData();
        },
        onClickNuovoFornitore() {
            let me = this;
            me.$refs.cmpConfigurazioniMagazzinoFornitoriList.onNuovoFornitore();
        },
        onUpdateFilter(filterData) {
            let me = this;
            me.filtroFornitore = filterData;
        },
    },
};
</script>
